import { Card, CardContent, CardHeader, Divider, Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { MonoText } from "components";
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import snakeToCamel from 'utils/snakeToTitle';


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0,
    paddingBottom: "0px !important"
  },
  actions: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& > * + *': {
      marginLeft: 0
    }
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  header: {
    fontWeight: 600
  }
}));

const InventoryInfo = props => {
  const { className, ...rest } = props;
  const model = useSelector(state => state.models.inventory);

  const classes = useStyles();

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Inventory Info" />
      <Divider />
      <CardContent className={classes.content}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell className={classes.header}>Type</TableCell>
              <TableCell>{snakeToCamel(model.type)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Reference</TableCell>
              <TableCell><MonoText>{model.reference}</MonoText></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

InventoryInfo.propTypes = {
  className: PropTypes.string,
};

export default InventoryInfo;
